<script setup lang="ts">
import { buffItemPresentation } from '@/buffs/presentation'
import type { BuffDisplayItem, BuffSnapshot } from '@/buffs/types'
import { computed } from 'vue'
import '@/buffs/strip.css'
const props = defineProps<{ item: BuffDisplayItem; snapshot: BuffSnapshot; size: number }>()
const state = computed(() => buffItemPresentation(props.item, props.snapshot))
// Use the resolved grid size, including compact rails that shrink below 24px.
const metrics = computed(() => {
  const [height, font, padding] = props.size >= 36 ? [12, 10, 2] : props.size >= 28 ? [11, 9, 2] : props.size >= 24 ? [10, 9, 1] : [9, 8, 1]
  return {
    '--buff-icon': `${props.size}px`,
    '--buff-time-height': `${height! / 16}rem`,
    '--buff-time-font': `${font! / 16}rem`,
    '--buff-time-padding': `${padding! / 16}rem`,
    '--buff-mark-size': `${(props.size >= 36 ? 10 : props.size >= 24 ? 8 : 7) / 16}rem`,
    '--buff-time-radius': props.size < 28 ? '.1875rem' : '.25rem',
  }
})
</script>
<template>
  <span class="buff-icon-wrap" :class="[`buff-icon-${state.status}`, { 'buff-icon-near': state.nearing, 'buff-icon-disabled': state.disabled }]" :style="metrics" aria-hidden="true">
    <img class="buff-icon" :src="item.imageUrl" alt="" draggable="false" :width="size" :height="size">
    <Transition name="buff-mark">
      <span v-if="!state.disabled && (state.status === 'unrecognized' || state.status === 'active')" :key="state.status" class="buff-status-mark" :class="`buff-status-${state.status}`">
        <svg v-if="state.status === 'active'" viewBox="0 0 12 12"><path d="m3 6 2 2 4-4" /></svg>
        <svg v-else viewBox="0 0 12 12"><path d="m4 4 4 4m0-4-4 4" /></svg>
      </span>
    </Transition>
    <Transition name="buff-time">
      <strong v-if="state.seconds !== null" class="buff-time">{{ state.seconds }}</strong>
    </Transition>
  </span>
</template>
